/* eslint-disable @typescript-eslint/no-explicit-any */
import { map } from 'es-toolkit/compat';

import { ClowncarSidebarSiteInfo } from 'components/sidebar/ClowncarSidebarSiteInfo';
import { Theme, css } from '@emotion/react';
import ClowncarMenuNavLink from 'components/menu/ClowncarMenuNavLink';
import ScrollLockComponent from '@tock/shared/components/ScrollLockComponent';

interface Props {
  sections: ClowncarMenuSections;
  variant?: 'primary' | 'secondary';
}

export interface ClowncarMenuSections {
  [section: string]: { exact?: boolean; text: string; to: string; hide?: boolean }[];
}

const clowncarMenuRoot = ({ colors }: Theme, variant: 'primary' | 'secondary') => css`
  background-color: ${variant === 'primary' ? colors.backgroundDarker : colors.backgroundLighter};
`;

const ClowncarMenu: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  sections,
  variant = 'primary',
  children,
}) => {
  return (
    <ScrollLockComponent
      className={'Navigation ClowncarMenu'}
      css={(Theme) => clowncarMenuRoot(Theme, variant)}
    >
      <nav className="ClowncarMenu-section ClowncarMenu-section--logo">
        <ClowncarSidebarSiteInfo />
      </nav>
      {map(sections, (links: any[], index) => (
        <nav className="ClowncarMenu-section" key={index}>
          {map(links, (link: any) => (
            <ClowncarMenuNavLink key={link.text} {...link} variant={variant} />
          ))}
        </nav>
      ))}
      {children}
    </ScrollLockComponent>
  );
};

export default ClowncarMenu;
